const pathMap: Record<string, string> = {
  "": "首页",
  celebrity: "明星榜",
  city: "国家与地区",
  country: "国家与地区",
  wordcloud: "词云",
  topics: "专题",
  compare: "对比",
  favorites: "收藏",
  analytics: "数据分析",
  search: "搜索",
  topic: "词条详情",
  guides: "使用指南",
  about: "关于热搜时光机",
  methodology: "数据方法",
  privacy: "隐私政策",
  terms: "服务条款",
  cookies: "Cookie 政策",
  daily: "每日热搜归档",
  history: "历史现场",
  douyin: "抖音热搜",
  login: "登录",
  register: "注册",
  auth: "认证",
  unsubscribe: "退订",
  "hot-search-engine": "热搜引擎说明",
  "weibo-hot-search-history": "历史热搜查询指南",
};

export function getBreadcrumbLabel(paths: string[], index: number): string {
  const path = paths[index] || "";
  if (paths[index - 1] === "topic") return "词条详情";
  if (pathMap[path]) return pathMap[path];
  try {
    return decodeURIComponent(path);
  } catch {
    return path;
  }
}
